"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Trigger;
var _react = _interopRequireWildcard(require("react"));
var _cccisdApollo = require("cccisd-apollo");
var _chart = _interopRequireDefault(require("cccisd-icons/chart"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _useDebounce3 = require("use-debounce");
var _List = _interopRequireDefault(require("./List"));
var _Header = _interopRequireDefault(require("./Header"));
var _Content = _interopRequireDefault(require("./Content"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _VizReport = _interopRequireDefault(require("./VizReport"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _utils = require("./Settings/utils.js");
var _getDataToVisualize = require("./getDataToVisualize.js");
var _populateMetric = _interopRequireDefault(require("./populateMetric.js"));
var _variablesWithContent = _interopRequireDefault(require("./variablesWithContent.graphql"));
var _rolesForGroupComparison = _interopRequireDefault(require("./rolesForGroupComparison.graphql"));
var _groupsForGroupComparison = _interopRequireDefault(require("./groupsForGroupComparison.graphql"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var counter = 0;
function Visualize(props) {
  var metrics = props.metrics,
    deploymentIds = props.deploymentIds,
    deployments = props.deployments,
    tableFilters = props.tableFilters,
    renderSaveQueryButton = props.renderSaveQueryButton,
    currentQuerySettings = props.currentQuerySettings,
    closeModal = props.closeModal,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = (0, _react.useState)(metrics[0].variableId),
    _useState4 = _slicedToArray(_useState3, 2),
    currentMetricId = _useState4[0],
    setCurrentMetricId = _useState4[1];
  var _useState5 = (0, _react.useState)(currentQuerySettings.visualizationSettings || {}),
    _useState6 = _slicedToArray(_useState5, 2),
    settings = _useState6[0],
    setSettings = _useState6[1];
  var _useDebounce = (0, _useDebounce3.useDebounce)(search, 500),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedSearch = _useDebounce2[0];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    vizData = _useState8[0],
    setVizData = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    groupComparisonOptions = _useState10[0],
    setGroupComparisonOptions = _useState10[1];
  var assignmentId = currentQuerySettings.assignmentId;
  var filteredMetrics = (0, _react.useMemo)(function () {
    var lowerCaseSearch = debouncedSearch.toLowerCase();
    return metrics.map(function (item, index) {
      return _objectSpread(_objectSpread({}, item), {}, {
        page: index + 1
      });
    }).filter(function (item) {
      return lowerCaseSearch.length === 0 || item.reportHeader.toLowerCase().includes(lowerCaseSearch);
    });
  }, [metrics, debouncedSearch]);
  var _useMemo = (0, _react.useMemo)(function () {
      var ids = filteredMetrics.map(function (m) {
        return m.variableId;
      });
      var currentIndex = ids.indexOf(currentMetricId);
      return {
        prevMetricId: currentIndex === -1 ? null : ids[currentIndex - 1] || null,
        nextMetricId: currentIndex === -1 ? null : ids[currentIndex + 1] || null
      };
    }, [filteredMetrics, currentMetricId]),
    prevMetricId = _useMemo.prevMetricId,
    nextMetricId = _useMemo.nextMetricId;
  var currentMetric = (0, _react.useMemo)(function () {
    return (0, _populateMetric["default"])(metrics.find(function (item) {
      return item.variableId === currentMetricId;
    }));
  }, [metrics, currentMetricId]);
  var currentMetricSettings = (0, _react.useMemo)(function () {
    return (0, _utils.getActualMetricSettings)(currentMetric, settings[currentMetricId], overrideInitialVisualizeSettings);
  }, [currentMetric, settings[currentMetricId], overrideInitialVisualizeSettings]);
  var currentCrossMetric = (0, _react.useMemo)(function () {
    if (!currentMetricSettings.compareWith) {
      return null;
    }
    var reportHeader = currentMetricSettings.compareWith.replace('variables.', '');
    return (0, _populateMetric["default"])(metrics.find(function (item) {
      return item.reportHeader === reportHeader;
    }));
  }, [metrics, currentMetricSettings]);
  var hasSettingsDiff = (0, _react.useMemo)(function () {
    return !(0, _isEqual2["default"])(settings, currentQuerySettings.visualizationSettings);
  }, [settings, currentQuerySettings]);
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var roles, response, options, _response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _cccisdApollo.client.query({
                query: _rolesForGroupComparison["default"],
                variables: {
                  deploymentIds: deploymentIds
                }
              });
            case 2:
              response = _context.sent;
              roles = response.data.flows.deploymentList.reduce(function (obj, item) {
                obj.add(item.role);
                (item.settings.otherAllowedRoles || []).forEach(function (role) {
                  obj.add(role);
                });
                return obj;
              }, new Set());

              // don't consider these roles
              roles["delete"]('uberadmin');
              roles["delete"]('questprojectadmin');
              _context.next = 8;
              return _cccisdApollo.client.query({
                query: _groupsForGroupComparison["default"],
                variables: {
                  roles: _toConsumableArray(roles)
                }
              });
            case 8:
              _response = _context.sent;
              options = _response.data.roles.anyRole.ancestorGroups.anyGroupList.filter(function (g) {
                return g.group.groupType !== 'questorganization' && g.group.groupType !== 'questproject';
              }).map(function (g) {
                var _window, _window$cccisd, _window$cccisd$appDef, _window$cccisd$appDef2, _window2, _window2$cccisd, _window2$cccisd$appDe, _window2$cccisd$appDe2, _window2$cccisd$appDe3, _window2$cccisd$appDe4;
                return {
                  value: g.group.groupType,
                  label: (_window = window) !== null && _window !== void 0 && (_window$cccisd = _window.cccisd) !== null && _window$cccisd !== void 0 && (_window$cccisd$appDef = _window$cccisd.appDefs) !== null && _window$cccisd$appDef !== void 0 && (_window$cccisd$appDef2 = _window$cccisd$appDef.pawn) !== null && _window$cccisd$appDef2 !== void 0 && _window$cccisd$appDef2.groups ? (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$cccisd = _window2.cccisd) === null || _window2$cccisd === void 0 ? void 0 : (_window2$cccisd$appDe = _window2$cccisd.appDefs) === null || _window2$cccisd$appDe === void 0 ? void 0 : (_window2$cccisd$appDe2 = _window2$cccisd$appDe.pawn) === null || _window2$cccisd$appDe2 === void 0 ? void 0 : (_window2$cccisd$appDe3 = _window2$cccisd$appDe2.groups) === null || _window2$cccisd$appDe3 === void 0 ? void 0 : (_window2$cccisd$appDe4 = _window2$cccisd$appDe3.find(function (gr) {
                    return gr.handle === g.group.groupType;
                  })) === null || _window2$cccisd$appDe4 === void 0 ? void 0 : _window2$cccisd$appDe4.label : g.group.groupType
                };
              });
              setGroupComparisonOptions(options);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
  var updateMetricSettings = function updateMetricSettings(metric, values) {
    var settingsToSave = (0, _utils.getMetricSettingsToSave)(metric, values);
    if (!settingsToSave) {
      setSettings((0, _omit2["default"])(settings, [metric.variableId]));
    } else {
      setSettings(_objectSpread(_objectSpread({}, settings), {}, _defineProperty({}, metric.variableId, settingsToSave)));
    }
  };
  var cleanCurrentMetricVizData = function cleanCurrentMetricVizData() {
    setVizData(function (prev) {
      return (0, _omit2["default"])(prev, [currentMetricId]);
    });
  };
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _getDataToVisualize.getDataToVisualize)({
                assignmentId: assignmentId,
                deploymentIds: deploymentIds,
                metric: currentMetric,
                metricSettings: currentMetricSettings,
                querySettings: currentQuerySettings,
                tableFilters: tableFilters
              });
            case 2:
              res = _context2.sent;
              setVizData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, currentMetricId, res));
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [currentMetricId, currentMetricSettings.comparison, currentMetricSettings.compareWith, currentMetricSettings.compareByGroupType]);

  // fetch data for all metrics
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var promises;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 2:
              promises = metrics.filter(function (metric) {
                return !vizData[metric.variableId];
              }).map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(metric) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return (0, _getDataToVisualize.getDataToVisualize)({
                            assignmentId: assignmentId,
                            deploymentIds: deploymentIds,
                            metric: metric,
                            metricSettings: (0, _utils.getActualMetricSettings)(metric, settings[metric.variableId], overrideInitialVisualizeSettings),
                            querySettings: currentQuerySettings,
                            tableFilters: tableFilters
                          });
                        case 2:
                          res = _context3.sent;
                          setVizData(function (prev) {
                            return prev[metric.variableId] ? prev : _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, metric.variableId, res));
                          });
                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref4.apply(this, arguments);
                };
              }());
              Promise.resolve(promises);
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }, []);
  function handleClose() {
    _cccisdApollo.taskMasterClient.cancelQueries('viz');
    closeModal();
  }
  var saveQueryButton = renderSaveQueryButton({
    hasChanges: hasSettingsDiff,
    currentQuerySettings: _objectSpread(_objectSpread({}, currentQuerySettings), {}, {
      visualizationSettings: settings
    })
  });
  var renderVizReport = function renderVizReport() {
    return /*#__PURE__*/_react["default"].createElement(_VizReport["default"], {
      metrics: metrics,
      vizData: vizData,
      deployments: deployments,
      settings: settings,
      overrideInitialVisualizeSettings: overrideInitialVisualizeSettings
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].backdrop
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].modal
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    className: _style["default"].closeButton,
    onClick: function onClick(e) {
      e.preventDefault();
      handleClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    metrics: metrics,
    filteredMetrics: filteredMetrics,
    search: search,
    setSearch: setSearch,
    currentMetricId: currentMetricId,
    setCurrentMetricId: setCurrentMetricId
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    prevMetricId: prevMetricId,
    nextMetricId: nextMetricId,
    setCurrentMetricId: setCurrentMetricId,
    saveQueryButton: saveQueryButton,
    renderVizReport: renderVizReport,
    metrics: metrics
  }), /*#__PURE__*/_react["default"].createElement(_Content["default"], {
    key: currentMetricId,
    currentMetric: currentMetric,
    currentCrossMetric: currentCrossMetric,
    prevMetricId: prevMetricId,
    nextMetricId: nextMetricId,
    setCurrentMetricId: setCurrentMetricId,
    currentMetricSettings: currentMetricSettings,
    deployments: deployments,
    data: vizData[currentMetricId]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    key: currentMetricId,
    currentMetric: currentMetric,
    currentMetricSettings: currentMetricSettings,
    currentCrossMetric: currentCrossMetric,
    updateMetricSettings: updateMetricSettings,
    metrics: metrics,
    cleanCurrentMetricVizData: cleanCurrentMetricVizData,
    groupComparisonOptions: groupComparisonOptions
  }))));
}
function Trigger(props) {
  var metrics = props.metrics,
    deploymentIds = props.deploymentIds,
    currentQuerySettings = props.currentQuerySettings;
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isOpen = _useState12[0],
    setIsOpen = _useState12[1]; // big modal state
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    metricsData = _useState14[0],
    setMetricsData = _useState14[1];
  (0, _react.useEffect)(function () {
    if (metrics.length === 0) {
      return;
    }
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var currentCounter, response, result;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              currentCounter = ++counter;
              setMetricsData(null);
              _context5.next = 4;
              return _cccisdApollo.client.query({
                query: _variablesWithContent["default"],
                variables: {
                  assignmentId: [currentQuerySettings.assignmentId],
                  reportHeaders: metrics
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all'
              });
            case 4:
              response = _context5.sent;
              if (!(currentCounter !== counter)) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return");
            case 7:
              // we need deduplicate list as we could have the same reportHeader for different languages
              result = (0, _uniqBy2["default"])(response.data.metrics.variableList, 'reportHeader').map(function (item) {
                var _item$key, _item$key2;
                var m = {
                  variableId: item.variableId,
                  reportHeader: item.reportHeader,
                  surveyHandles: item.surveyHandles,
                  type: item.type,
                  label: item.label,
                  question: item.key.title,
                  content: item.key.content,
                  isIdentifying: Boolean(item === null || item === void 0 ? void 0 : (_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.isIdentifying),
                  questionType: item.key.questionType,
                  "enum": (_item$key2 = item.key) === null || _item$key2 === void 0 ? void 0 : _item$key2.enumList,
                  enumCoding: item.enumCoding,
                  minimum: item.key.minimum,
                  maximum: item.key.maximum,
                  isFile: item.tagList.some(function (obj) {
                    return obj.scope === 'system' && obj.handle === 'fileUpload';
                  })
                };
                m.statisticType = function () {
                  if (Object.keys(m.content).includes('enum')) {
                    if (m.enumCoding && (Object.keys(m.enumCoding).every(function (v) {
                      return Number.isInteger(Number(v));
                    }) || Object.values(m.enumCoding).every(function (v) {
                      return Number.isInteger(Number(v));
                    }))) {
                      return ['categorical', 'numeric'];
                    }
                    return ['categorical'];
                  }
                  return ['numeric'];
                }();
                return m;
              });
              setMetricsData(result);
            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }, [metrics]);
  var disabledReason = function () {
    if (deploymentIds.length === 0) {
      return 'Missing data collection waves';
    }
    if (currentQuerySettings.surveyHandles.length === 0) {
      return 'Missing surveys';
    }
    if (metrics.length === 0) {
      return 'No metrics to visualize';
    }
    return null;
  }();
  if (disabledReason) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: disabledReason.reason
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      disabled: true
    }, /*#__PURE__*/_react["default"].createElement(_chart["default"], {
      spaceRight: true
    }), "Visualize"));
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_chart["default"], {
    spaceRight: true
  }), "Visualize"), function () {
    if (!isOpen) {
      return null;
    }
    if (!metricsData) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true
      });
    }
    return /*#__PURE__*/_react["default"].createElement(Visualize, _extends({}, props, {
      metrics: metricsData,
      closeModal: function closeModal() {
        return setIsOpen(false);
      }
    }));
  }());
}